// LOGGED IN CONSTANTS
export const LOGGED_IN_GREETING = "Hi";
export const LOGGED_IN_GREETING_WO_NAME = "Hello";
export const LOGGED_IN_MY_ACC_URL =
  "/myaccountlogin?v1=/myaccountlogin&sso-module=cart&sso-product=Profile&sso-form-post=/SSO/SingleSignOn";
export const NATIVE_APP_DEEP_LINK = "inAppDeepLink://";

// NON LOGGED IN CONSTANTS
export const NON_LOGGED_IN_MY_ACC_URL =
  "/myaccountlogin?v1=/myaccountlogin&sso-module=myaccount&sso-product=Home&sso-form-post=/SSO/SingleSignOn";

// SECTION TITLE CONSTANTS
export const SEC_TITLE_SEARCH = "Search";
export const SEC_TITLE_SEARCH_HISTORY = "Search History";
export const SEC_TITLE_SEARCH_SUGGESTIONS = "Search Suggestions";
export const SEC_TITLE_BACK_ICON = "back icon";
export const SEARCH_PLACEHOLDER_EN = "Search Bajaj Finance";
export const SEARCH_PLACEHOLDER_HI = "बजाज फ़ाइनेंस ढूँढें";
export const SEC_TITLE_PARTNERS = "Partners";
export const SEC_TITLE_NOTIFICATIONS = "Notifications";
export const SEC_TITLE_NOTIFICATIONS_HINDI = "नोटिफिकेशन";
export const MENU_EN = "Menu";
export const MENU_HI = "मेन्यू";
